import { SheetSVG } from "@/components/SheetSVG";
import { SectionSheet } from "@/components/sheets/SectionSheet";
import { AssemblySheet } from "@/components/sheets/AssemblySheet";
import { CatalogueDetailSheet } from "@/components/sheets/CatalogueDetailSheet";
import { OfficialSheet } from "@/components/sheets/OfficialSheet";
import { BomSheet } from "@/components/sheets/BomSheet";
import { ThreeSheet } from "@/components/sheets/ThreeSheet";
import { CoverSheet } from "@/components/sheets/CoverSheet";
import { detailsFor, chunk } from "@/lib/details";

export const SHEETS = { elevation: SheetSVG, official: OfficialSheet, catalogue: CatalogueDetailSheet, sections: SectionSheet, assembly: AssemblySheet, bom: BomSheet, three: ThreeSheet, cover: CoverSheet };

const VIEWS = [["elevation", "Elevation"], ["official", "IWIN-S"], ["catalogue", "Catalogue"], ["sections", "Sections"], ["assembly", "Assembly"], ["3d", "3D"]];

export const ViewSwitch = ({ view, setView }) => (
  <div className="flex h-8 rounded-md border border-slate-700 overflow-hidden mr-1" data-testid="view-switch">
    {VIEWS.map(([v, l]) => (
      <button key={v} data-testid={`view-${v}-btn`} onClick={() => setView(v)}
        className={`px-2.5 text-[11px] font-mono uppercase tracking-wider transition-colors ${view === v ? "bg-cyan-500 text-slate-950" : "text-slate-400 hover:bg-slate-800"}`}>{l}</button>
    ))}
  </div>
);

export const SheetPreview = ({ item, tb, view, leading }) => {
  const Comp = SHEETS[view];
  const pages = view === "catalogue" ? (chunk(detailsFor(item), 4).length ? chunk(detailsFor(item), 4) : [[]]) : [null];
  return (
    <div className="flex-1 flex flex-col min-w-0 min-h-0" data-testid={`sheet-preview-${view}`}>
      <div className="h-12 px-3 flex items-center gap-2 border-b border-slate-800 bg-[#0d1220]">
        {leading}
        <span className="ml-auto font-mono text-[11px] uppercase tracking-wider text-slate-500 hidden xl:block">A3 sheet preview · included in PDF if ticked at export</span>
      </div>
      <div className="flex-1 overflow-auto bg-[#0B0F19] cad-grid p-6 space-y-6">
        {pages.map((details, i) => (
          <div key={i} className="mx-auto max-w-[1400px] shadow-2xl shadow-black/60 fade-in [&>svg]:w-full [&>svg]:h-auto">
            <Comp item={item} tb={tb} sheetNo={i + 1} total={pages.length} details={details || undefined} />
          </div>
        ))}
      </div>
    </div>
  );
};
